import { inject, Injectable, Injector } from '@angular/core';
import { WorkTimeReport } from '@app/shared/types/models/reports/work-time-report';
import { WorkTimeReportDTO } from '../../dtos/reports/work-time-report.dto';
import { UsersDataService } from '../../users-data.service';
import { AbstractFactory } from '../abstract.factory';
import { ReportMappers } from './report-mappers';
import { WorkTimeRegistrationFactory } from './work-time-registration.factory';

@Injectable({ providedIn: 'root' })
export class WorkTimeReportFactory extends AbstractFactory<WorkTimeReportDTO, WorkTimeReport> {
  private readonly injector: Injector = inject(Injector);
  private readonly usersService: UsersDataService = this.injector.get<UsersDataService>(UsersDataService);
  private readonly workTimeRegistrationFactory: WorkTimeRegistrationFactory =
    this.injector.get<WorkTimeRegistrationFactory>(WorkTimeRegistrationFactory);

  public produce(item: WorkTimeReportDTO): WorkTimeReport {
    if (!item) {
      return undefined;
    }
    if (item.user) {
      this.usersService.upsertLocalData(item.user);
    }
    if (item.createdBy) {
      this.usersService.upsertLocalData(item.createdBy);
    }

    return new WorkTimeReport({
      id: item.id,
      description: item.description,
      status: ReportMappers.mapStatus(item.status),
      date: new Date(item.date),
      duration: item.duration,
      dateFrom: item.dateFrom ? new Date(item.dateFrom) : undefined,
      dateTo: item.dateTo ? new Date(item.dateTo) : undefined,
      user: item.user?.id ? this.usersService.getById(item.user.id) : undefined,
      reportType: 'WorkTime',
      createdBy: item.createdBy?.id ? this.usersService.getById(item.createdBy.id) : undefined,
      createdOn: new Date(item.createdOn),
      comments: item.comments,
      registration: item.registration ? this.workTimeRegistrationFactory.produce(item.registration) : undefined,
      taskId: item.taskId,
      projectId: item.project?.id,
      locationId: item.locationId ?? item.location?.id,
      // nested task/project are hydrated by WorkTimeReportContextMapper
      task: undefined,
      location: item.location ? { id: item.location.id, name: item.location.name } : undefined,
      project: undefined,
      hoursType: ReportMappers.mapHoursType(item.hoursType),
      standardHoursDuration: item.standardHoursDuration,
      bankHoursDuration: item.bankHoursDuration,
      overtime50Duration: item.overtime50Duration,
      overtime100Duration: item.overtime100Duration,
      diet: item.diet,
      privateKm: item.privateKm,
      expenses: item.expenses,
      otherExpenses: item.otherExpenses
    });
  }
}
